import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext, Store } from '@ngxs/store';
import { ProfilesActions } from './profiles.actions';
import { SosApiService } from '../../common/services/api/api.service';
import { PROFILES_TOKEN } from './profiles.const';
import { tap } from 'rxjs/operators';

export interface ProfilesStateModel {
    profiles: any[]; // Replace `any` with a real Profile interface if available
    loaded: boolean;
}

@State<ProfilesStateModel>({
    name: PROFILES_TOKEN,
    defaults: {
        profiles: [],
        loaded: false
    },
})
@Injectable()
export class ProfilesState {
    constructor(private sosApiService: SosApiService, private store: Store) {}

    @Action(ProfilesActions.FetchProfiles)
    fetchProfiles({ patchState }: StateContext<ProfilesStateModel>) {
        return this.sosApiService.get('client/profiles').pipe(
            tap({
                next: (response) => patchState({ profiles: response.data, loaded: true, }),
                error: () => patchState({ profiles: [], loaded: true, }),
            })
        );
    }

    @Selector()
    static allProfiles(state: ProfilesStateModel) {
        return state.profiles;
    }
}
